<script>
import modalDeleteAccount from "../modals/modal-delete-account";

export default {
  name: "dangerZone",
  components: {
    modalDeleteAccount,
  },
  computed: {
    curAccount: function () {
      return _.get(this, '$A.Auth.account', {});
    },
  },
  methods: {
    deleteAccount: function () {
      this.$refs.deleteAccountModal.openModal();
    },
  },
  mounted() {
    let self = this;
    this.$root.$on("account::delete::confirmation", function () {
      self.$A.AccountService.DeleteAccount();
    });
  },
};
</script>

<template>
  <div class="settings-card danger-card">
    <div class="card-head">
      <div class="card-head-title danger-title">Delete Account</div>
      <div class="card-head-subtitle">This action will delete all files and user data on your account. It cannot be undone.</div>
    </div>
    <div class="card-foot">
      <a class="danger-btn" @click="deleteAccount">Delete Account</a>
    </div>
    <modalDeleteAccount
        ref="deleteAccountModal"
        :accountName="curAccount.name"
    />
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(235, 70, 84, 0.25);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
}
.danger-title {
  color: #b43643;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.danger-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  background: #eb4654;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.danger-btn:hover {
  background: #d23a47;
  color: #fff;
  text-decoration: none;
}
@media (max-width: 575px) {
  .danger-btn {
    width: 100%;
  }
}
</style>
